import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.component.scss'],
    imports: [NgClass]
})
export class RadioButtonComponent  {
  @Input() userForm;
  @Input() configValue;
  @Output() toggleContainer: EventEmitter<any> = new EventEmitter();
  constructor() { }


  buttonClick = (ev, btn) => {
    this.configValue.forEach(config => {
      config.isActive = false;
    });
    btn.isActive = true;
    this.toggleContainer.emit(btn);
  }
}
